import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { PhoneIcon } from 'lucide-react';
const ease = [0.23, 1, 0.32, 1] as const;
export function BookingCta() {
  return <section className="bg-signal py-24 md:py-32" data-id="element-66" data-mp="a7ib5tt9emv4">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-67" data-mp="aaxrezyo61y4">
        <h2 className="font-display text-[15vw] uppercase leading-[0.85] md:text-[9rem]" data-id="element-68" data-mp="f6d43okxxrsy">
          {['Allô ?', 'On joue', 'chez vous.'].map((line, i) => <span key={line} className="block overflow-hidden" data-id="element-69" data-mp="598f7gzpni8g" data-mpi={i}>
              <motion.span className={`block ${i === 2 ? 'text-ink' : 'text-paper'}`} initial={{
            y: '100%'
          }} whileInView={{
            y: '0%'
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.3,
            delay: i * 0.07,
            ease
          }} data-id="element-70" data-mp="5arx1c10m1cc">
                {line}
              </motion.span>
            </span>)}
        </h2>
        <div className="mt-10 flex flex-col gap-6 md:flex-row md:items-center md:justify-between" data-id="element-71" data-mp="3iq7tw96h196f">
          <p className="max-w-md text-lg text-paper/90" data-id="element-72" data-mp="146kqougb3h5w">
            Festival, fête municipale, salle ou soirée privée : dites-nous la date et le lieu, on revient vers vous
            rapidement.
          </p>
          <div className="flex flex-wrap gap-3" data-id="element-73" data-mp="1e51l61egedwp">
            <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-ink px-7 py-4 font-semibold text-paper transition-transform duration-150 hover:-translate-y-0.5 active:scale-[0.97]" data-id="element-74" data-mp="1e59z7wmbbp9h">
              <PhoneIcon className="h-4 w-4" data-id="element-75" data-mp="z7rauvdjre2k" /> Demander une date
            </Link>
            <Link to="/formules" className="inline-flex items-center whitespace-nowrap rounded-full border-2 border-paper px-7 py-4 font-semibold text-paper transition-colors duration-150 hover:bg-paper hover:text-signal" data-id="element-76" data-mp="uh169kcy3f8x">
              Voir les formules
            </Link>
          </div>
        </div>
      </div>
    </section>;
}